import { Logo } from "@/components/brand/Logo";
import { Button } from "@/components/ui/button";
import { NOT_FOUND_META } from "@/lib/prerender-html";
import { useEffect } from "react";
import { Link } from "react-router-dom";

/** 없는 주소. 랜딩의 "체류의 선"이 여기서 끊긴다 — 이어지는 길(처음으로·콘솔)을 둘 다 준다. */
export function NotFoundPage() {
  // 탭·방문 기록에서 다른 페이지와 구분되게(nginx 는 이 화면을 404 상태로 준다).
  useEffect(() => {
    const previous = document.title;
    document.title = NOT_FOUND_META.title;
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <div className="bg-atmosphere grain flex min-h-dvh flex-col justify-center px-6 py-16">
      <a href="#main" className="skip-link">
        본문으로 건너뛰기
      </a>
      <main id="main" tabIndex={-1} className="relative z-10 mx-auto w-full max-w-3xl outline-none">
        <Link
          to="/"
          aria-label="Stayline 홈"
          className="brand-link inline-block rounded-[10px]"
        >
          <Logo size={36} withWordmark />
        </Link>
        <p className="mt-16 text-[13px] font-semibold tabular-nums text-muted-foreground">404</p>
        <h1 className="mt-3 break-keep font-display text-4xl font-extrabold leading-[1.08] tracking-[-0.04em] text-foreground sm:text-6xl">
          선이 여기서 끊겼어요.
        </h1>
        <p className="mt-5 max-w-[32rem] break-keep text-base leading-relaxed text-muted-foreground">
          주소가 바뀌었거나 없는 페이지예요. 게스트 안내 링크를 열다 여기로 왔다면 숙소에 새 링크를
          요청해 주세요.
        </p>
        <div aria-hidden="true" className="mt-12 flex items-center">
          <span className="h-[11px] w-[11px] shrink-0 rounded-full bg-[#b4501a]" />
          <span className="h-px flex-[3] bg-foreground/70" />
          <span className="w-6 shrink-0" />
          <span className="h-px flex-1 bg-foreground/15" />
        </div>
        <div className="mt-12 flex flex-wrap gap-3">
          <Button asChild className="btn-sweep">
            <Link to="/">처음으로</Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="btn-sweep btn-sweep--ink hover:text-background focus-visible:text-background"
          >
            <Link to="/admin">콘솔로 이동</Link>
          </Button>
        </div>
      </main>
    </div>
  );
}
